export class FilterRecetaDoctor {
  idSucursal: string | null;
  idMedico: string | null;

  constructor(filter: FilterRecetaDoctor) {
    this.idSucursal = filter.idSucursal || null;
    this.idMedico = filter.idMedico || null;
  }
}
